module.exports = __webpack_public_path__ + "vue/img/captura-logo.f0e73541.svg";